module.exports = "/_next/static/images/ico-chat-cd0fe1d1cf164899d887a801e7449aa3.svg";